<style src="styles/components/base/Preloader.styl" lang="stylus"></style>

<script>
    import {mapActions} from "vuex"
    import {ASSET_LOADING, DATA} from "@/app/store/modules/app"
    import preloader from "@/app/utils/preloader"
    import ApiLoader from "foo/net/ApiLoader"
    import PreloaderTransition from "@/app/transitions/PreloaderTransition"
    import LineIcon from '@/app/components/LineIcon'

    export default {
        name: "Preloader",
        data(){
            return {
                progress: 0,
                loading: true,
                iconVisible: false,
            }
        },
        props: {
            minDisplayTime: {
                type: Number,
                default: 1500
            },
            transitionMode: {
                type: String,
                default: "simultaneous"
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        xhrImages: false,
                        loadFullAudio: false,
                        loadFullVideo: false,
                    }
                }
            },
        },
        components: {
            PreloaderTransition,
            LineIcon,
        },
        async mounted(){
            this.iconVisible = true
            await Promise.all([
                ApiLoader.load(),
                this.setTimer(),
                this.setLoader(),
            ])
            this.loadingComplete()
        },
        methods: {
            setTimer(){
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve()
                    }, this.minDisplayTime)
                })
            },
            setLoader(){
                return new Promise((resolve) => {
                    this.loader = preloader
                    this.loader.on("progress", this.onProgress)
                    this.loader.on('complete', () => this.onComplete(resolve))
                    this.load()
                })
            },
            add(url, options = {}){
                this.loader.add(url, options)
            },
            load(){
                this.loader.load()
            },
            onProgress(val){
                this.progress = val
            },
            onComplete(done){
                this.progress = 1
                const data = preloader.get(require('assets/data/data.json'))
                this.$store.commit(DATA, data)
                done()
            },
            loadingComplete(){
                this.transitionMode === "out-in" ? this.transitionOut() : this.setDone()
            },
            transitionOut() {
                this.iconVisible = false
                // Give the icon sometime to do its outro
                TweenLite.delayedCall(0.3, () => {
                    this.loading = false
                })
            },
            setDone(){
                this.loadingState(false)
            },
            ...mapActions({
                loadingState: ASSET_LOADING,
            })
        },
        computed: {
            icon() {
                const { $store } = this
                return $store.getters.data.loaderIcon
            },
        },
    }
</script>

<template>
    <preloader-transition>
        <div class="Preloader" v-if="loading">
            <line-icon
                v-show="iconVisible"
                class="Preloader-icon"
                :width="70"
                :height="30"
                :loop="true"
                light
                opaque
                d="M0.9,24c13.6,0,26.4-7.7,33.7-16c0.6-0.7,1.3-1.5,
                1.5-2.4c0.1-0.4-0.3-0.8-0.7-0.7c-5.1,1.3-11.7,14.3-6.7,
                14.6c5.7,0.3,19.5-6.2,24.2-12.7c0.6-0.9-0.1-2.1-1.2-1.8C46.4,
                6.4,36.6,18,38.6,23.4c2.1,5.7,19.6-5.2,30.4-5.2"
            ></line-icon>
        </div>
    </preloader-transition>
</template>



// WEBPACK FOOTER //
// src/app/components/base/Preloader.vue